/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type { GetMockableUsersQueryResponse } from '../models/GetMockableUsers.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getMockableUsersQueryResponseSchema } from '../zod/getMockableUsersSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getMockableUsersQueryKey = () =>
  [{ url: '/api/impersonation' }] as const;

export type GetMockableUsersQueryKey = ReturnType<
  typeof getMockableUsersQueryKey
>;

/**
 * {@link /api/impersonation}
 */
export async function getMockableUsers(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetMockableUsersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/impersonation`, ...requestConfig });
  return getMockableUsersQueryResponseSchema.parse(res.data);
}

export function getMockableUsersQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getMockableUsersQueryKey();
  return queryOptions<
    GetMockableUsersQueryResponse,
    ResponseErrorConfig<Error>,
    GetMockableUsersQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getMockableUsers(config);
    },
  });
}

/**
 * {@link /api/impersonation}
 */
export function useGetMockableUsers<
  TData = GetMockableUsersQueryResponse,
  TQueryData = GetMockableUsersQueryResponse,
  TQueryKey extends QueryKey = GetMockableUsersQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetMockableUsersQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getMockableUsersQueryKey();

  const query = useQuery(
    {
      ...getMockableUsersQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
